module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACsSURBVHgBbY1BDsFAFIbfm041dpxAIrElDuEEWJI4QFe2dtY9g0g3MmVhPYfALEhH4gpEtFOJdHQISvyb9+d/X/LhZTfzbIdOnWpHwJ/EMnARyIZY1F6nNz1X20XlF1IyGCGCm0RnQYq1tp9tPtCUH1eT0hsKWQ8Q+mCRVrk5OH0UIfOUZNz062FZjyXbm/v647eKcQ3YMJ0iGRaetkdIHkwiu6u1Ftk4zkMmd1XDPrTTIN/UAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workOrderReview/extendIcon.png
// module id = G4Sz
// module chunks = 0